import { Pipe, PipeTransform } from '@angular/core';
import { GLOBAL_VARIABIALES } from '../constants/static-variable';

@Pipe({
  name: 'companyType'
})
export class CompanyTypePipe implements PipeTransform {

  transform(companyTypeData?: any) {

    var companyTypeName=''

    GLOBAL_VARIABIALES.TYPE_OF_COMPANY.forEach(element => {
        if(element.code === companyTypeData){
            companyTypeName = element.label;
        }
    });


    return companyTypeName;
  }

}
